import React from "react";

function AMMDexDev() {
  return (
    <>
      <div
        className="about-style-three-area default-padding bg-gray bg-cover"
        style={{ background: "url(assets/img/shape/banner-16.html)" }}
      >
        <div className="container">
          <div className="row">
            <div className="col-lg-6">
              <h4 className="sub-title">AI writing assistant</h4>
              <h2 className="title split-text-right split-text-in-right">
                AMM DEX Development by Xeer Technology
              </h2>
              {/* <p>
               Transform Your Trading Experience with Automated Market Makers
              </p> */}
              <p>
                At Xeer Technology, we specialize in developing cutting-edge
                Automated Market Maker (AMM) Decentralized Exchanges (DEXs) that
                redefine the way users trade and provide liquidity in the
                decentralized finance (DeFi) ecosystem. Our AMM DEX solutions
                leverage innovative algorithms and blockchain technology to
                facilitate seamless trading, enabling users to swap tokens
                directly against liquidity pools without relying on traditional
                order books.
              </p>
              <a className="btn btn-style-one" href="#">
                Know more
              </a>
            </div>
            <div className="col-lg-6">
              <div className="about-style-three-thumb">
                <img
                  className="fade-up-anim"
                  src="https://validthemes.net/site-template/robok/assets/img/illustration/dashboard-4.jpg"
                  alt="Image Not Found"
                />
                <img
                  className="fade-up-anim"
                  src="https://validthemes.net/site-template/robok/assets/img/illustration/1.gif"
                  alt="Image Not Found"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default AMMDexDev;
